import { format, startOfMonth } from "date-fns";
import { getMonthNameWithYear } from "helpers/date";
import { InspectionInfoDto } from "pages/app/service-schedule/service-schedule.dto";

/**
 * Första planerade tillfälle för en besiktningstyp får vara innevarande månad
 * eller senare. Är kunden medveten om att besiktningen är försenad väljs
 * innevarande månad.
 */
export const isValidInitialInspectionMonth = (
  date: Date | null | undefined,
  now = new Date(),
) => !date || startOfMonth(date) >= startOfMonth(now);

/**
 * Värdet som skickas till servern för ett första planerat datum.
 * - historik finns: fältet utelämnas (servern räknar själv)
 * - påminnelsen är av eller datumet tomt: null (nollställ)
 * - annars 'YYYY-MM-15', uttryckt i lokal månad så att tidszon inte
 *   flyttar valet till föregående månad.
 */
export const toInitialInspectionDatePayload = (
  avtal: boolean | undefined,
  date: Date | null | undefined,
  hasHistory: boolean,
): string | null | undefined => {
  if (hasHistory) {
    return undefined;
  }
  if (!avtal || !date) {
    return null;
  }
  return format(date, "yyyy-MM-15");
};

/** Datum från servern ('YYYY-MM-15') till Date för månadsväljaren. */
export const fromInitialInspectionDate = (
  value: string | null | undefined,
): Date | null => {
  if (!value) {
    return null;
  }
  const [year, month] = value.split("-").map(Number);
  if (!year || !month) {
    return null;
  }
  return new Date(year, month - 1, 1);
};

/**
 * Finns redan en planerad, pågående eller utförd uppgift av typen för objektet?
 * Då är första planerade datum inte längre relevant.
 */
export const hasInspectionHistory = (info?: InspectionInfoDto) =>
  !!info?.lastUppdrag || !!info?.nextOccurance?.uppdragUuid;

/**
 * Etikett för nästa tillfälle i prioritetsordning: bokat uppdrag, beräknat
 * datum (från historik eller första planerade datum), annars undefined.
 */
export const getNextInspectionLabel = (
  info?: InspectionInfoDto,
): string | undefined => {
  const next = info?.nextOccurance;
  if (!next) {
    return undefined;
  }
  if (next.uppdragUuid && next.uppdragDate) {
    return next.uppdragDate;
  }
  if (next.reminderDate) {
    return getMonthNameWithYear(next.reminderDate);
  }
  return undefined;
};
